import React from "react";

/**
 * 파일명: Profile.js
 * 작성자: 권도훈
 * 작성일자: 23.04.06
 * 설명: 마이페이지 Profile
 */
function Profile() {
  return <>프로필</>;
}

export default Profile;
